module.exports = __webpack_public_path__ + "static/media/pic1.c166f287.jpg";